import { render, staticRenderFns } from "./EditConfigHome.vue?vue&type=template&id=25391ed0"
import script from "./EditConfigHome.vue?vue&type=script&lang=js"
export * from "./EditConfigHome.vue?vue&type=script&lang=js"
import style0 from "./EditConfigHome.vue?vue&type=style&index=0&id=25391ed0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports